import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/services';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //(URLs que no deben setear Content-Type JSON para evitar CORS)
    const isGoogleStorage = request.url.includes('storage.googleapis.com');
    const isOcrService = request.url.includes('ocr.ms.mrpresta.com');
    if (isGoogleStorage || isOcrService) {
        return next.handle(request);
    }
    let currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.web_token) {
      let token = currentUser.web_token;
      request = request.clone({
        setHeaders: {
          "Content-Type": "application/json",
          "api-token": token,

          ...(request.headers.has('x-protected-action') && {
            'protected-action': request.headers.get('x-protected-action'),
          }),

          ...(currentUser && {
            'user-email': String(currentUser.email),
            'user-profile': String(currentUser.profileId),
            'user-id': String(currentUser.userId),
          })

        }
      });
    }
    return next.handle(request);
  }

}
